import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QuoteWizard } from '../../components/quote/QuoteWizard';
import type { Quote } from '../../types/quote';

export function CreateQuote() {
  const navigate = useNavigate();
  const [createdQuote, setCreatedQuote] = useState<Quote | null>(null);

  const handleQuoteCreated = useCallback((quote: Quote) => {
    // Navigate back to quotes list with success message
    navigate('/admin/quotes', {
      state: { 
        newQuote: quote,
        message: `Quote ${quote.quoteNumber} created successfully!`
      }
    });
  }, [navigate]);

  const handleCancel = useCallback(() => {
    // Navigate back to quotes list
    navigate('/admin/quotes');
  }, [navigate]);

  // Listen for quote creation during step 1 to transition to edit mode
  useEffect(() => {
    const checkForCreatedQuote = () => {
      const draftData = localStorage.getItem('quote-wizard-draft');
      if (draftData) {
        try {
          const parsed = JSON.parse(draftData);
          const quote = parsed?.data?.quote;
          if (quote?.id && quote?.quoteNumber && !createdQuote) {
            console.log('🔄 DRAFT QUOTE CREATED: Transitioning to edit mode', quote.quoteNumber);
            setCreatedQuote(quote);
            
            // Update the localStorage data to indicate we should start at step 2
            const updatedParsed = {
              ...parsed,
              data: {
                ...parsed.data,
                currentWizardStep: 2  // Start at step 2 in edit mode
              }
            };
            localStorage.setItem('quote-wizard-draft', JSON.stringify(updatedParsed));
            
            // Transition to edit mode by navigating to edit page
            navigate(`/admin/quotes/${quote.id}/edit`, { replace: true });
          }
        } catch (error) {
          console.error('Error parsing draft data:', error);
        }
      }
    };

    // Check immediately and then periodically
    checkForCreatedQuote();
    const interval = setInterval(checkForCreatedQuote, 1000);
    
    return () => clearInterval(interval);
  }, [navigate, createdQuote]);

  return (
    <div className="min-h-screen bg-gray-50 py-6">
      <QuoteWizard
        onComplete={handleQuoteCreated}
        onCancel={handleCancel}
      />
    </div>
  );
} 